export const environment = {
    production: false,
    apiUrl: "https://data-dev.advocate-digital.com/api"
};